module.exports = __webpack_public_path__ + "static/media/Island Warrior.5490448d.jpg";